import PropTypes from 'prop-types';
import React, {Component} from 'react';
import DashboardApi from '../../../api/dashboard.jsx';
import Loader from '../loader.jsx';
import StackedBarChart  from '../charts/stackedBarChart';
import {FormattedMessage, intlShape, injectIntl} from 'react-intl';
import AdminOnly from 'ui/layout/AdminOnly';
import {makeCancelable} from 'helpers/cancelablePromise';
import {bindLocaleUpdate} from 'helpers/bindLocaleUpdate';


class AvgWaterTestsPerAccount extends Component {
  static propTypes = {
    intl: intlShape.isRequired,
    start: PropTypes.any,
    end: PropTypes.any,
    branch: PropTypes.any,
    branches: PropTypes.array,
    POS: PropTypes.bool,
    timeframe: PropTypes.string,
  };

  constructor(props) {
    super(props);
    this.state = {
      report: null,
      loaded: false,
      currentTimeFrameReport: null,
    };
  }

  componentDidMount() {
    this.onUpdate();
  }

  componentWillUpdate(nextProps) {
    if (nextProps.POS !== this.props.POS ||
      nextProps.branch !== this.props.branch ||
      nextProps.branches !== this.props.branches ||
      nextProps.timeframe !== this.props.timeframe ||
      nextProps.start !== this.props.start ||
      nextProps.end !== this.props.end
    ) {
      this.onUpdate(nextProps);
    }
  }

  componentWilUnmount() {
    if (this.fetching && !this.fetching.isFinished) {
      this.fetching.cancel();
    }
  }

  onUpdate(props = this.props) {
    const {branch, branches} = props;

    if (this.fetching && !this.fetching.isFinished) {
      this.fetching.cancel();
    }

    (this.fetching = makeCancelable(DashboardApi.getAvgWaterPerAccount(branch === -1 ? branches : branch,
        props.start, props.end, props.timeframe)))
      .then(data => {
        let parsedData = [];

        for (let strCount of Object.keys(data)) {
          parsedData.push({
            frequency: parseInt(strCount),
            pool: parseInt(data[strCount]['1']) || 0,
            spa: parseInt(data[strCount]['2']) || 0,
            swimSpa: parseInt(data[strCount]['3']) || 0,
          });
        }

        this.setState({
          report: parsedData,
          loaded: true,
          currentTimeFrameReport: parsedData[parsedData.length - 1],
        });
      })
      .catch(err => {
        console.log(err);
        this.setState({
          loaded: false,
        });
      });
  }

  render() {
    const {report, loaded} = this.state;
    let {formatMessage} = this.props.intl;

    return (
      <div className='avg-test-account-report expanded-tile'>
        {report ?
          <Loader loaded={loaded}>
            <div className='row'>
              <div className='col-sm-12'>
                <div className='report-header'>
                  <AdminOnly>
                    <a className='dashboard-report-view-link pull-right'
                       href='#reports/water/analysis-accounts'>
                      <span className='underline'><FormattedMessage id="general.view.report" /></span> <i className='bl bl-right_arrow' />
                    </a>
                  </AdminOnly>

                  <h2 className='title'><FormattedMessage id="posdashboard.number.active.accounts" /></h2>
                  <hr/>
                </div>
              </div>
            </div>
            <div className='row'>
              <div className='col-sm-12'>
                <div className='report-graph'>
                  <StackedBarChart data={report}
                    verticalAxisTitle={formatMessage({id: 'posdashboard.number.customers'})}
                    horizontalAxisTitle={formatMessage({id: 'posdashboard.number.water.analyses'})}
                    colors={['#4D9ACF', '#B0B7BD', '#3bc2cd']}
                    titleField='frequency'
                    valueFields={['pool', 'spa', 'swimSpa']}
                    balloonTexts={[
                      '<b>[[value]]</b> ' + formatMessage({id: 'posdashboard.pools.with'}) +
                        ' <b>[[category]]</b> ' + formatMessage({id: 'posdashboard.water.analyses'}) + '.',
                      '<b>[[value]]</b> ' + formatMessage({id: 'posdashboard.spas.with'}) +
                        ' <b>[[category]]</b> ' + formatMessage({id: 'posdashboard.water.analyses'}) + '.',
                      '<b>[[value]]</b> ' + formatMessage({id: 'posdashboard.swimspas.with'}) +
                        ' <b>[[category]]</b> ' + formatMessage({id: 'posdashboard.water.analyses'}) + '.',
                    ]}
                    horizontalLabelRotation={0}
                    fixedColumnWidth={25}
                    fillAlphas={0.75}
                  />
                </div>
              </div>
            </div>
          </Loader> :
          <div />}
      </div>
    );
  }
}

export default injectIntl(bindLocaleUpdate(AvgWaterTestsPerAccount));
